import { useFormikContext } from "formik";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import { TextField } from "@mui/material";

import { CompletionUserInput } from "@baiki/interfaces";

export const ComposeForm = () => {
  const { t } = useTranslation();
  const { handleChange, errors, touched, values } =
    useFormikContext<CompletionUserInput>();

  const whoFieldRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      whoFieldRef.current?.focus();
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <TextField
        inputRef={whoFieldRef}
        error={touched.who && Boolean(errors.who)}
        fullWidth
        helperText={errors.who || t("fields.who.helperText")}
        id="who"
        label={t("fields.who.label")}
        margin="normal"
        multiline
        name="who"
        onChange={handleChange}
        placeholder={t("fields.who.placeholder")}
        type="text"
        value={values.who}
      />
      <TextField
        error={touched.what && Boolean(errors.what)}
        fullWidth
        helperText={errors.what || t("fields.what.helperText")}
        id="what"
        label={t("fields.what.label")}
        margin="normal"
        multiline
        name="what"
        onChange={handleChange}
        placeholder={t("fields.what.placeholder")}
        type="text"
        value={values.what}
      />
    </>
  );
};
